module.exports = __webpack_public_path__ + "static/media/megaphone.b4137a66.svg";